import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import {RootState} from "@/store/RootState";
import {ITimeslotRestriction} from "@/store/modules/settingsModule";
import responseHandler from "@/plugins/errorHandling";

export interface IZone {
  id: number;
  name: string;
  created_at: string;
}

interface ZonesState {
  zones: IZone[];
  restrictions: ITimeslotRestriction[],
  errors: IErrors;
}

const state: ZonesState = {
  zones: [],
  restrictions: [],
  errors: {},
};

const getters: GetterTree<ZonesState, RootState> = {
  zones: (state): IZone[] => state.zones,
  restrictions: (state): ITimeslotRestriction[] => state.restrictions,
  errors: (state) => state.errors,
};

const actions: ActionTree<ZonesState, RootState> = {
  fetchZones: ({ commit, state }): any => responseHandler.debounce<IZone[]>(
    state.zones,
    null,
    () => axios({
      url: settings.endpoint + 'settings/zones',
    }),
    commit,
    'zonesLoaded'
  ),
  createZone: ({ commit }, {zone}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'settings/zones',
      method: 'POST',
      data: {
        name: zone,
      }
    }),
    commit,
    'zonesLoaded'
  ),
  fetchZoneRestrictions: ({ commit}, zoneId): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'settings/zones/' + zoneId + '/restrictions',
      method: 'GET',
    }),
    commit,
    'restrictionsLoaded'
  ),
  createZoneRestriction: ({ commit }, {zoneId, dayOfWeek, data}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'settings/zones/' + zoneId + '/restrictions',
      method: 'POST',
      data: {
        weekday: dayOfWeek,
        data: data
      }
    }),
    commit,
    'restrictionsLoaded'
  ),
  deleteZoneRestriction: ({ commit }, {zoneId, restrictionId}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'settings/zones/' + zoneId + '/restrictions/' + restrictionId,
      method: 'DELETE',
    }),
    commit,
    'restrictionsLoaded',
  ),
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  }

};

const mutations: MutationTree<ZonesState> = {
  zonesLoaded(state, payload) {
    state.zones = payload;
  },
  restrictionsLoaded(state, payload) {
    state.restrictions = payload;
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },

};

const namespaced: boolean = true;

export const zonesModule: Module<ZonesState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
